import React, { Component } from 'react';
import __ from 'lodash';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import { CONFIG, CONFIG_API_BE, URL_AKM } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import akmApi from '../../../../../apis/akmApi';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import {Row, Col, Alert,Form} from 'react-bootstrap';
import {Bar} from 'react-chartjs-2';

import LoaderModal from '../../../../modal/LoaderModal';
import Loader from '../../../../Loader';
import PrintActions from '../../../../PrintActions';
import '../../../../AdminReportPrint.css';
import {validateAdminReport} from '../../../../../utils/adminReportData';


import './report.css';


class Report extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            isFetching : false,
            alertShow: false,
            resMessage: "message",
            tahunAjaran : [],
            provinsi: [],
            kota: [],
            sekolah: [],
            idProvinsi : null,
            idKota : null,
            idSekolah : null,
            namaSekolahSearch : null,
            taAktif : null,
            dataInfo: {},
            dataMapel: [],
            dataIndikator: [],
            dataSK: [],
            dataSLB: [],
            dataIndekSosial: []
        }
    }

    async componentDidMount() { 
        //await this.props.cekCookies();
       // if(!__.isEmpty(this.props.account)) {

        //}
        this.fetchReport();
        const queryParams = new URLSearchParams(this.props.location.search);
        console.groupCollapsed("========== rptakm ==========");
        console.info('props', this.props);
        console.info('idJadwal', queryParams.get('idJadwal'));
        console.info('idSekolah', queryParams.get('idSekolah'));
        console.info('idKelas', queryParams.get('idKelas'));
        console.info('idKelasParalel', queryParams.get('idKelasParalel'));
        console.groupEnd();
    }

    fetchReport = async() => {   
        const queryParams = new URLSearchParams(this.props.location.search);
        this.setState({isFetching:true, alertShow:false, dataInfo:{}, dataMapel:[], dataIndikator:[], dataSK:[], dataSLB:[], dataIndekSosial:[]})
        // const response = await akmApi.get(URL_AKM.GET_REPORT, {
        //     params: { 
        //             idJadwal:  this.props.match.params.idJadwal, 
        //             idSekolah:  this.props.match.params.idSekolah, 
        //             idKelas:  this.props.match.params.idKelas,
        //             idKelasParalel: this.props.match.params.idKelasParalel === 'null' ? null :  this.props.match.params.idKelasParalel}
        // })
        try {
        const response = await akmApi.get(URL_AKM.GET_REPORT, {
            params: { 
                    idJadwal:  queryParams.get('idJadwal'), 
                    idSekolah:  queryParams.get('idSekolah'), 
                    idKelas:  queryParams.get('idKelas'),
                    idKelasParalel: queryParams.get('idKelasParalel') === 'null' ? null :  queryParams.get('idKelasParalel')}
        })
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                if(response.data.data !== null) {
                    const report = validateAdminReport(response.data.data);
                    this.setState({ 
                        dataInfo: report,
                        dataMapel: report.dataMapel,
                        dataIndikator: report.dataIndikator,
                        dataSK: report.dataNonAkademik.SK,
                        dataSLB: report.dataNonAkademik.SLB,
                        dataIndekSosial: report.indekSosial
                    });
                }               

            } else {
                this.setState({                
                    resMessage: response.data.errorSchema.errorMessage,                
                    isFetching: false,
                    alertShow: true
                }) 
            }  
            this.setState({isFetching:false})
        }
        } catch (error) {
            this.setState({dataInfo: {}, alertShow: true, resMessage: 'Laporan belum dapat dimuat. Muat ulang lalu coba lagi.'});
        } finally {
            this.setState({isFetching: false});
        }
    } 

    renderChart(title, values) {
        let data = [];
        let label = [];

        values.map(item => {
            data.push(item.jumlah);
            label.push(item.kategori);
        })        
        return(
            <>
                <Bar
                    data={{
                        labels: label,
                        datasets: [{
                            label: title,
                            data: data,
                            backgroundColor: [
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(54, 162, 235, 0.2)',
                                'rgba(255, 206, 86, 0.2)',
                                'rgba(75, 192, 192, 0.2)'
                            ],
                            borderColor: [
                                'rgba(255, 99, 132, 1)',
                                'rgba(54, 162, 235, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(75, 192, 192, 1)'
                            ],
                            borderWidth: 1
                        }]
                    }}
                    height="100%"
                    options = {{  
                        legend: {
                            labels: {                                
                                fontSize: 14
                            }
                        },                      
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    min: 0,
                                    max: this.state.dataInfo.peserta,
                                    //stepSize: 1
                                },
                                gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                }
                            }],
                            xAxes: [{
                                gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                }
                            }],
                        }                        
                    }}
                />
                
            </>             
        )

    }

    render(){
        const {dataInfo, dataMapel, dataIndikator,dataSK, dataSLB, dataIndekSosial} = this.state;
        const reportReady = !__.isEmpty(dataInfo) && [dataMapel, dataIndikator, dataSK, dataSLB, dataIndekSosial].some(items => Array.isArray(items) && items.length > 0);
        return(
            <div className="container-fluid admin-report-page" style={{paddingBottom: '50px'}}>
                <LoaderModal isFetching={this.state.isFetching}/> 
                {this.loadAlert()}
                <PrintActions disabled={this.state.isFetching || this.state.alertShow || !reportReady} />
                <Row>
                    <Col>
                        <div className="header-title-1">
                            SCHOOL REPORT
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="header-title-2">
                            SIMULASI ASESMEN NASIONAL – EDUPRIME
                        </div>
                    </Col>
                </Row>
                <br></br>

                {/* =========== BIODATA  ========== */}
                <Row>
                    <Col>
                        <div className="biodata-kiri">
                            Sekolah : {dataInfo.sekolah}
                        </div>
                    </Col>
                    <Col>
                        <div className="biodata-kiri">
                            Tgl Ujian : {dataInfo.tanggal}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="biodata-kiri">
                        Kelas : {dataInfo.kelas}
                        </div>
                    </Col>
                    <Col>
                        <div className="biodata-kiri">
                            Peserta : {dataInfo.peserta} siswa
                        </div>
                    </Col>
                </Row>
                <br></br>

                {/* ============ AKM ============= */}
                <Row>
                    <Col>
                        <div className="judul-akm ">
                            SIMULASI ASESMEN NASIONAL – EDUPRIME
                        </div>
                    </Col>
                </Row>
                <Row style={{"padding":"15px"}}>
                    {dataMapel.map((mapel,i) => 
                    <Col key={i}>
                        <table width="100%" border="1" >
                            <thead>
                                <tr>
                                    <th colSpan="3" className="header-table-detail-akm">{mapel.namaMataPelajaran}</th>
                                </tr>
                                <tr>
                                    <th className="text-center" rowSpan="3">KATEGORI</th>
                                    <th className="text-center" colSpan="2">JUMLAH</th>
                                </tr>
                                <tr>
                                    <th className="text-center">SISWA</th>
                                    <th className="text-center">%</th>
                                </tr>
                            </thead>
                            <tbody>
                                {mapel.kategories.map((kateg, j) => 
                                <tr key={j}>
                                    <td>{kateg.kategori}</td>
                                    <td className="text-center">{kateg.jumlah}</td>
                                    <td className="text-center">{(Math.round(kateg.jumlah * 100) / dataInfo.peserta).toFixed(2)} %</td>
                                </tr>
                                )}                                
                            </tbody>
                        </table>
                    </Col>
                    )}                    
                </Row>
                <br></br>

                {/* ============ CHART ============= */}
                <Row>
                {dataMapel.map((mapel,idx) =>                 
                    <Col key={idx}>                         
                        {this.renderChart(mapel.namaMataPelajaran, mapel.kategories)}                        
                    </Col>                
                )}
                </Row>
                <hr className="garis"></hr>

                {/* =========== INDIKATOR ============ */}

                {dataIndikator.map((data,idx) => 
                <Row key={idx} className="admin-print-block">
                    <Col>
                        <div className="judul-mapel">{data.namaMataPelajaran}</div>
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th colSpan="3">Indikator</th>
                                    <th className="text-center">Tuntas</th>
                                    <th className="text-center">Tidak Tuntas</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.indikator.map((indi, i) => 
                                <tr>
                                    <td colSpan="3">{indi.namaIndikator}</td>
                                    <td className="text-center">{indi.tuntas}</td>
                                    <td className="text-center">{indi.tidakTuntas}</td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </Col>
                </Row>            
                )}
                <hr className="garis"></hr>
                
                {/* ================================================================================================================= */}
                {/* ============ SURVEY KARAKTER ============= */}
                <Row>
                    <Col>
                        <div className="judul-sk ">
                            SURVEY KARAKTER
                        </div>
                    </Col>
                </Row>
                <div className="row" style={{"marginTop" : "10px"}}>
                    <div className="col-md-12">
                        <div className="row">
                        {/* == GRAFIK == */}
                            <div className="col-md-6">
                                {/* looping */}
                                {dataSK.map((data,i) => 
                                <div className="row" key={i}>
                                    <div className="col-md-4">
                                        {data.aspek}
                                    </div>
                                    <div className="col-md-8">
                                        <div className="graph">
                                            <div className="bg-graph val-graph" style={{ width: data.jumlah + '%' }}></div>
                                        </div> 
                                    </div>
                                </div>
                                )}  
                            </div>
                            
                            {/* == TABEL == */}
                            <div className="col-md-6">
                                <div className="row">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Profil Pelajar Pancasila</th>
                                                <th>Rata-Rata Skor Siswa</th>
                                                <th>Kategori</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* diloop */}
                                            {dataSK.map((data,i) => 
                                            <tr key={i}>
                                                <td>{data.aspek}</td>
                                                <td className="text-center">{data.jumlah}</td>
                                                <td className="text-center">{data.kategori}</td>
                                            </tr>
                                            )} 
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br></br>
                <hr className="garis"></hr>

                {/* ============ SURVEY KARAKTER ============= */}
                <Row>
                    <Col>
                        <div className="judul-slb ">
                            SURVEY LINGKUNGAN BELAJAR
                        </div>
                    </Col>
                </Row>
                <div className="row" style={{"marginTop" : "10px"}}>
                    <div className="col-md-12">
                        <div className="row">
                        {/* == GRAFIK == */}
                            <div className="col-md-6">
                                {/* looping */}
                                {dataSLB.map((data,i) => 
                                <div className="row" key={i}>
                                    <div className="col-md-4">
                                        {data.aspek}
                                    </div>
                                    <div className="col-md-8">
                                        <div className="graph">
                                            <div className="bg-graph val-graph" style={{ width: data.jumlah + '%' }}></div>
                                        </div> 
                                    </div>
                                </div>
                                )}
                            </div>
                            
                            {/* == TABEL == */}
                            <div className="col-md-6">
                                <div className="row">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Profil Pelajar Pancasila</th>
                                                <th>Rata-Rata Skor Siswa</th>
                                                <th>Kategori</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* diloop */}
                                            {dataSLB.map((data,i) => 
                                            <tr key={i}>
                                                <td>{data.aspek}</td>
                                                <td className="text-center">{data.jumlah}</td>
                                                <td className="text-center">{data.kategori}</td>
                                            </tr>
                                            )} 

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br></br>

                <Row className="admin-print-block">
                    <Col>
                        <div className="judul-ise">
                            INDEKS SOSIAL-EKONOMI SISWA
                        </div>

                        <div>
                            Berdasarkan angket Survei Lingkungan Belajar terkait Indeks Sosial Ekonomi, diperoleh data sebagai berikut
                        </div>

                        <table className="table table-bordered">
                            <thead>
                                <tr>                                    
                                    <th className="text-right">Banyak Siswa</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataIndekSosial.map((data,i) => 
                                <tr key={i}>
                                    <Row>
                                        <Col sm={3}>{data.soal}</Col>
                                        <Col sm={9}>                                            
                                            {data.kategori.map((v,j) => 
                                            <Row key={j}>
                                                <Col sm={10}>{v.namaKategori}</Col>
                                                <Col sm={2} className="text-center">{v.jumlah}</Col>
                                            </Row>
                                            
                                            )}   
                                            
                                        </Col>
                                    </Row>
                                    <hr></hr>
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </Col>
                </Row>

                <Row><Col></Col></Row>
                <hr className="garis"></hr>
            
            </div>
        )
    }


    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }
        
    loadAlert = () => {
        const {alertShow } = this.state;      
        if (alertShow) {
          return (
            <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }  

}


export default Report;
